import * as React from "react";
import { useTheme } from "@emotion/react";
import { forwardRef } from "react";
import { css, cx } from "@emotion/css";
const SvgUserUnfollow = forwardRef(({
  title,
  titleId,
  desc,
  descId,
  ...props
}, ref) => {
  const theme = useTheme();
  let {
    color,
    colorSecondary,
    size,
    sizeH,
    sizeW,
    height: heightProp,
    width: widthProp,
    shadow,
    animatedProps,
    hex,
    ...other
  } = props;
  const height = heightProp ?? theme.iconSizes?.[sizeH ?? size];
  if (height) {
    other.height = height;
  }
  const width = widthProp ?? theme.iconSizes?.[sizeW ?? size];
  if (width) {
    other.width = isNaN(width) ? "100%" : width;
  }
  let fill = other.fill ?? theme.color?.icon[color];
  let fillSecondary = other.fillSecondary ?? theme.color?.icon[colorSecondary];
  const { className: classNameProp } = other;
  const className = css({
    filter: shadow ? theme.shadows.drop : void 0,
    minHeight: height,
    minWidth: width,
    clipPath: hex ? "url(#rounded-hex-clip-path)" : void 0
  });
  other.className = cx(className, classNameProp);
  if (color === "heading") {
    fill = "url(#harmony-gradient)";
  }
  ;
  other.role = title ? "img" : void 0;
  other["aria-hidden"] = title ? void 0 : true;
  props = {
    ...other,
    ref,
    fill,
    fillSecondary
  };
  return /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, "aria-describedby": descId, ...props }, desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.0357 13.5611C16.2213 13.3755 16.5222 13.3755 16.7078 13.5611L18.3882 15.2414L20.0685 13.5611C20.2541 13.3755 20.555 13.3755 20.7406 13.5611L21.8608 14.6813C22.0464 14.8669 22.0464 15.1678 21.8608 15.3534L20.1805 17.0338L21.8608 18.7141C22.0464 18.8997 22.0464 19.2006 21.8608 19.3862L20.7406 20.5064C20.555 20.692 20.2541 20.692 20.0685 20.5064L18.3882 18.8261L16.7078 20.5064C16.5222 20.692 16.2213 20.692 16.0357 20.5064L14.9155 19.3862C14.7299 19.2006 14.7299 18.8997 14.9155 18.7141L16.5958 17.0338L14.9155 15.3534C14.7299 15.1678 14.7299 14.8669 14.9155 14.6813L16.0357 13.5611ZM6.01495 12.3575C7.11999 13.3055 8.55646 13.878 10.1267 13.878C11.0462 13.878 11.9199 13.6816 12.7081 13.3286C11.6505 15.4992 11.6456 18.4104 12.8747 20.3721C8.14301 20.8691 2 20.0339 2 17.8661C2 15.5185 3.61259 13.4668 6.01495 12.3575ZM10.1267 3.35449C12.6201 3.35449 14.6415 5.37584 14.6415 7.8693C14.6415 10.3628 12.6201 12.3841 10.1267 12.3841C7.6332 12.3841 5.61185 10.3628 5.61185 7.8693C5.61185 5.37584 7.6332 3.35449 10.1267 3.35449Z", fill: props.fill }));
});
export default SvgUserUnfollow;
